export const REFRESH_DISCUSSIONS_INTERVAL = 10000; // 10 seconds
export const DISCUSSIONS_TO_SHOW = 10;
